export const openFileInNewTab = (file) => {
  const link = document.createElement('a');
  link.href = file;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};